export function getCurrentProgress(questions, answers) {
  let totalAnswers = answers ? Object.keys(answers)?.length ?? 0 : 0
  let totalQuestions = questions?.length ?? 1

  let percentage =
    totalQuestions < totalAnswers ? 100 : (totalAnswers / totalQuestions) * 100

  return `${Math.round(percentage)}%`
}
